<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { inquiryUser, merge, Yhdelete, huquyh, getPwdVerify } from '../../../../../api/home.js';
import { hex_md5 } from '../../../../../../md5.js';
import configHttp from '../../../../../../configHttp.js';
export default {
	name: 'UserManagement',
	data() {
		var checkPhone = (rule, value, callback) => {
			if (!value) {
				callback();
			} else {
				const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
				if (reg.test(value)) {
					callback();
				} else {
					return callback(new Error('请输入正确的手机号'));
				}
			}
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (this.enterText.resetpassword !== '') {
					this.$refs.enterText.validateField('resetpassword');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.enterText.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			Count: 0,
			subject: false,
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('UserManagementheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('UserManagementoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			chasx: '',
			//新增修改数据
			enterText: {
				id: '',
				userCode: '',
				userName: '',
				password: '',
				resetpassword: '',
				userType: '3',
				email: '',
				state: '1',
				phone: ''
			},
			oldPassword: '',
			title: '',
			examine: false,
			rules: {
				userCode: [{ required: true, message: '请输入用户代码', trigger: 'blur' }],
				userName: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
				password: [{ required: true, validator: validatePass, trigger: 'blur' }],
				resetpassword: [{ required: true, validator: validatePass2, trigger: 'blur' }],
				email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
				phone: [{ validator: checkPhone, trigger: 'blur' }]
			},
      userPwdVerify: {}
		};
	},
	created() {
		this.usermanagepaging();
		if(configHttp.projectType !='Amat'){
			getPwdVerify().then(res => {
				this.userPwdVerify = res.data.data;
			});
		}
	},
	mounted() {},
	methods: {
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('UserManagementoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('UserManagementheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		//查看
		chak(v) {
			this.enterText = {
				id: v.id,
				userCode: v.userCode,
				userName: v.userName,
				password: v.password,
				userType: v.userType,
				email: v.email,
				state: v.state,
				phone: v.phone
			};
			this.examine = true;
		},

		rousesubject(v) {
			if (v) {
				this.title = '编辑用户';
				let params = { id: v.id };
				huquyh(params).then(res => {
					if (res.data.code == '200') {
						this.enterText = {
							id: res.data.data.id,
							userCode: res.data.data.userCode,
							userName: res.data.data.userName,
							password: '******',
							resetpassword: '******',
							password1: res.data.data.password,
							resetpassword1: res.data.data.password,
							userType: res.data.data.userType,
							email: res.data.data.email,
							state: res.data.data.state,
							phone: res.data.data.phone
						};
						this.oldPassword = res.data.data.password;
					}
				});
			} else {
				this.title = '新增用户';
				this.enterText = {
					id: '-1',
					userCode: '',
					userName: '',
					password: '',
					resetpassword: '',
					userType: '3',
					email: '',
					state: '1',
					phone: ''
				};
			}
			this.$nextTick(() => {
				this.$refs['enterText'].clearValidate();
			});
			this.subject = true;
		},
		//删除用户
		Delete(userCode) {
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				let params = { userCode: userCode };
				Yhdelete(params).then(res => {
					if (res.data.code == '200') {
						this.$message.success('删除成功');
					} else {
						this.$message.error(res.data.message);
					}
					this.usermanagepaging();
				});
			});
		},
		//删除用户
		Deletes() {
			if (this.$refs.tablebox.getSelectionval().length != 1) {
				this.$message.error('只能操作一条数据！');
				return;
			}
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {};
					params.userCode = this.$refs.tablebox
						.getSelectionval()
						.map(v => v.userCode)
						.join(',');

					Yhdelete(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('删除成功');
						} else {
							this.$message.error(res.data.message);
						}
						this.usermanagepaging();
					});
				}
			});
    },
    pwdVerify() {
		if(configHttp.projectType !='Amat'){
			  let password = this.enterText.password;
			  const regex = new RegExp(this.userPwdVerify.regex);
			  if (!regex.test(password) || password.length < this.userPwdVerify.minlen) {
				this.$message.error(this.userPwdVerify.regexText);
				return false;
			  } else {
				return true;
			  }
		}else{
			return true;
		}
    },
		//新增编辑
		AddEdit() {
			this.$refs.enterText.validate(valid => {
				if (valid) {
					let params = {};
					params.id = this.enterText.id;
					params.userCode = this.enterText.userCode;
					params.userName = this.enterText.userName;
					if (this.enterText.id != '-1') {
						if (this.enterText.password == '******') {
							params.password = this.enterText.password1;
            } else {
              let res = this.pwdVerify();
              if (!res) {
                return;
              }
              params.password = hex_md5(this.enterText.password);
            }
					} else {
						if (this.oldPassword == this.enterText.password) {
							params.password = this.enterText.password;
						} else {
              let res = this.pwdVerify();
              if (!res) {
                return;
              }
							params.password = hex_md5(this.enterText.password);
						}
					}
					params.userType = this.enterText.userType;
					params.email = this.enterText.email;
					params.state = this.enterText.state;
					params.phone = this.enterText.phone;
					merge(params).then(res => {
						if (res.data.code == '200') {
							this.subject = false;
							this.usermanagepaging();
							this.$message.success('保存成功');
						} else {
							this.$message.error(res.data.message);
						}
					});
				} else {
					return false;
				}
			});
		},
		//分页查询
		usermanagepaging() {
			let params = {};
			params.page = this.pagination.pageNum;
			params.size = this.pagination.pageSize;
			params.sort = '';
			params.order = '';
			params.criteriaJson = JSON.parse(JSON.stringify("{userName:'" + this.chasx + "'}"));
			inquiryUser(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.usermanagepaging();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.usermanagepaging();
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
